import { withTranslation } from 'react-i18next';

import { ContentLayout } from 'Layout';

function WorkforceTabsNavigation({ t, disabled = false }) {
  return (
    <ContentLayout.TabsNavigation disabled={disabled}>
      <ContentLayout.TabLink disabled={disabled} label={t('workforce:tabs.roles')} to="/workforce/roles" />
      <ContentLayout.TabLink disabled={disabled} label={t('workforce:tabs.people')} to="/workforce/people" />
    </ContentLayout.TabsNavigation>
  );
}

export default withTranslation('workforce')(WorkforceTabsNavigation);
